import { create } from 'zustand';
import type { InboxProviderId } from '@/services/inboxSync';

type TripDetectionSession = {
  taskId: string;
  userId: string;
  provider: InboxProviderId;
  label: string;
};

type TripDetectionSessionState = {
  session: TripDetectionSession | null;
  setSession: (session: TripDetectionSession) => void;
  clearSession: () => void;
};

export const useTripDetectionSessionStore = create<TripDetectionSessionState>((set) => ({
  session: null,
  setSession: (session) => set({ session }),
  clearSession: () => set({ session: null }),
}));
